import React, { useState } from "react";
import { connect } from "react-redux";
import { dl_insurances } from "../../reducers/dl_insurance.reducer";
import { dealjackets } from "../../reducers/dealjacket.reducer";
import { dl_insuranceActions, dealjacketActions, alertActions } from "../../actions";
import { dl_insuranceConstants, dealjacketConstants } from "../../constants";
import { OrgDropdown } from "../org/OrgDropdown";
import { DateTimeDisplay } from "../common/DateTimeDisplay";
import { Feedback } from "./Feedback";

// Copied from EditDealName
function AssignDealNumber(props) {
  const {
    org_id,
    assignDealNumber,
    newToken,
    deal_number_input_entry, // as searched by user
    current_submission_selected, // from the list of identity jackets (on the left)
    check_deal_number_response, // from server if jacket(s) found or not (from dealjackets reducer)
    // NOTE: check_deal_number_response state is managed in both dealjackets and dl_insurance reducers.
    jackets_matching_requested_number, // array from server if jackets found, per org.
    deal_jacket_created_result, // single deal jacket object of newly create jacket
    deal_jacket_to_add_to, // either selected or newly created deal jacket
    deal_jacket_with_identity_documents, // final result of successfull call to add or assign endpoint
    last_added_identity_document_packet, // tracking most recently added identity jacket
    alert_message, // within assign deal number window
    alert_type, // sets the css class within assign deal number window alert container
    dl_insurance_processing_state, // used during upload (and processing if necessary)
    jacket_listing, // full listing of submitted identity jackets
  } = props;

  // Build vars to compare for display decisions
  let feedback_heading = "Select a DL & Insurance pack from the list on the left to add to an existing, or create new deal jacket."
  let feedback_subheading = "";
  let feedback_activity = (dl_insurance_processing_state) ? "adding_files" : "";
  let feedback_data = {};
  let feedback_prompt = "";
  let button_text = "Add/Create";
  let cancel_button = "";

  const [newDealNumber, setNewDealNum] = useState();

  const handleDealNumberInput = (e) => {
    props.updateDealNumberInputField(e.target.value);
  };

  const checkOrAssignDealNumber = (e) => {
    if (!deal_number_input_entry) return;
    if (!current_submission_selected) {
      return props.displayAlertMessage("Select a package to submit.", "error");
    }

    if (deal_jacket_with_identity_documents) {
      // Docs have already been added, so clear state for next transaction.
      props.clearSelectedDealJacketFromState();
    }

    if (check_deal_number_response?.message == dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_FAILURE) {
      // If we hadn't found a match, we are creating a deal jacket now.
      return props.createDealJacketFromDealNumber(org_id, deal_number_input_entry);
    }

    if (deal_jacket_to_add_to?.deal_jacket_id) {
        // There is a jacket to add to, so we are associating the ID packet with it.
        props.clearSelectedDealJacketFromState();
        return props.assignIdentityToJacket(deal_jacket_to_add_to.deal_jacket_id, current_submission_selected, jacket_listing);
    }

    return props.getDealNumberMatches(org_id, deal_number_input_entry);
  };

  const clearDealNumberRequest = () => {
    props.clearDealNumberRequestFromState();
    props.clearSelectedDealJacketFromState();
  }

  let deal_number_input_field = <label className="dealLabel">
      Deal Number:
      <input
        className="dealNameInput"
        autoComplete="off"
        type="text"
        name="dealNumber"
        value={deal_number_input_entry || ""}
        onChange={handleDealNumberInput}
      ></input>
  </label>

  let display_cancel_button = <span
  id="save"
  className="classifyFormButton"
  name="resetFormButton"
  onClick={clearDealNumberRequest}
  form="assigndealnumber"
>
  Cancel
  </span>

  /**
   * States under consideration
   *  current_submission_selected user has selected an identity jacket
   *  check_deal_number_response we either found or did not find matching jacket(s)
   *  jackets_matching_requested_number we DID find matching jacket(s) (possibly with warning)
   *  deal_jacket_created_result we created a new jacket
   *  deal_jacket_with_identity_documents we have added id documents to jacket (removed from main listing)
   */
  if (current_submission_selected) {
    /**
     * User can add to existing or create new deal jacket
     */
    feedback_heading = "Add DL & Insurance from " + (current_submission_selected.customer_name || "Name Undetermined") + ".";
    feedback_subheading = <>
      (<DateTimeDisplay date={new Date(current_submission_selected.date_added)} />)
    </>

    if (check_deal_number_response?.message === dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_FAILURE) {
      feedback_heading = "Deal number not found. Would you like to create a jacket with deal number " + deal_number_input_entry + "?";
      feedback_subheading = "";
      button_text = "Create";
      deal_number_input_field = "";
      cancel_button = display_cancel_button;
    }

    if ((check_deal_number_response !== undefined &&
        check_deal_number_response.type === dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_SUCCESS) &&
        jackets_matching_requested_number) {
      // TODO: Support possibility of multiple orgs. In general, I think there could be
      // more of a method to this state checking madness, both in the display and button
      // activity above. I guess I'd like to be able to really see WHAT the possible
      // state combinations are, so that there's less poking around at the interface in
      // development. – MikeiLL
      feedback_heading = "Found deal number " + deal_number_input_entry + ".";
      feedback_subheading = "";
      feedback_data = jackets_matching_requested_number;
      feedback_activity = "found_a_match";
      feedback_prompt = "Add documents for [Name Not Extracted]?";
      if (current_submission_selected?.customer_name) {
        feedback_prompt = "Add documents for " + current_submission_selected?.customer_name + "?";
      }

      button_text = "Add";
      deal_number_input_field = "";
      cancel_button = display_cancel_button;
    }

    if (deal_jacket_created_result) {
      feedback_heading = "Jacket created.";
      feedback_subheading = "With deal number: " + (deal_jacket_created_result.deal_number || "Undetermined") + ".";
      feedback_prompt = "Would you like to add these documents to it?";
      button_text = "Add Documents";
      deal_number_input_field = "";
      cancel_button = display_cancel_button;
    }


  } else {
    /**
     * current_submission_selected is either not yet set by user
     * or cleared because identity jacket has been added
     */
    if (deal_jacket_with_identity_documents?.deal_jacket_id) {

      feedback_heading = "Documents Added";

      if (last_added_identity_document_packet?.customer_name) {
        feedback_heading = last_added_identity_document_packet.customer_name + " Documents Added";
      }

      feedback_subheading = "(Jacket: " + deal_jacket_with_identity_documents.deal_jacket_name + " (" + deal_jacket_with_identity_documents.deal_number + "))";
      feedback_prompt = "Select a DL & Insurance pack from the list on the left to add to an existing, or create new deal jacket."
    }
  }

  return (
    <>
      <div className="dlInsuranceAssignDealNumberFeedback">
        <Feedback
          heading={feedback_heading}
          subheading={feedback_subheading}
          activity={feedback_activity}
          data={feedback_data}
          prompt={feedback_prompt}
          alert_message={alert_message}
          alert_type={alert_type} />
      </div>
      <div>
        {deal_number_input_field}
      <br />
      <span
        id="save"
        className="classifyFormButton"
        name="saveButton"
        onClick={checkOrAssignDealNumber}
        form="assigndealnumber"
      >
        {button_text}
        </span>
        {cancel_button}
      </div>
    </>
  );
}

function mapStateToProps(state) {
  // destructure the required objects.
  const { dl_insurances, dealjackets } = state;
  return {
    deal_number_input_entry: dl_insurances.deal_number_input_entry,
    current_submission_selected: dl_insurances.current_submission_selected,
    check_deal_number_response: dealjackets.check_deal_number_response,
    jackets_matching_requested_number: dl_insurances.jackets_matching_requested_number,
    deal_jacket_created_result: dl_insurances.deal_jacket_created_result,
    deal_jacket_to_add_to: dl_insurances.deal_jacket_to_add_to,
    deal_jacket_with_identity_documents: dl_insurances.deal_jacket_with_identity_documents,
    last_added_identity_document_packet: dl_insurances.last_added_identity_document_packet,
    alert_message: dl_insurances.alert_message,
    alert_type: dl_insurances.alert_type,
    dl_insurance_processing_state: dl_insurances.dl_insurance_processing_state,
    jacket_listing: dl_insurances.list
  };
}

const actionCreators = {
  assignDealNumber: dl_insuranceActions.assignDealNumber,
  updateDealNumberInputField: dl_insuranceActions.updateDealNumberInputField,
  getDealNumberMatches: dealjacketActions.getDealNumberMatches,
  clearDealNumberRequestFromState: dl_insuranceActions.clearDealNumberRequestFromState,
  clearSelectedDealJacketFromState: dl_insuranceActions.clearSelectedDealJacketFromState,
  createDealJacketFromDealNumber: dl_insuranceActions.createDealJacketFromDealNumber,
  errorAlert: alertActions.error,
  assignIdentityToJacket: dl_insuranceActions.assignIdentityToJacket,
  displayAlertMessage: dl_insuranceActions.displayAlertMessage,
};

const connectedAssignDealNumber = connect(
  mapStateToProps,
  actionCreators
)(AssignDealNumber);
export { connectedAssignDealNumber as AssignDealNumber };
